import type { PostMessageClient } from "@connect/post-message/client";
import type { BuyButtonFrameMessageMap } from "@connect/post-message/protocol";
import type { BuyButtonConfig } from "../config";
import type { PaymentInstrument, PaymentMethodLabel } from "../../../lib/buy/create-transaction";
import type { SignedQuote } from "../../../lib/buy/quote.types";
import { type CreateOutcome, runCreate } from "./run-create";
import { runPreCheck } from "./run-pre-check";

export interface RunHeadlessPurchaseParams {
  quote: SignedQuote;
  config: BuyButtonConfig;
  pm: PostMessageClient<BuyButtonFrameMessageMap>;
  instrument: PaymentInstrument;
  paymentMethod: PaymentMethodLabel;
  isCancelled: () => boolean;
  kycStepUp: { current: boolean };
  /** Overridable for tests. */
  preCheck?: typeof runPreCheck;
  /** Overridable for tests. */
  create?: typeof runCreate;
}

/** The card button's tap, without the tap: pre-check, then create. "stopped" means the pre-check didn't pass. */
export async function runHeadlessPurchase({
  quote,
  config,
  pm,
  instrument,
  paymentMethod,
  isCancelled,
  kycStepUp,
  preCheck = runPreCheck,
  create = runCreate,
}: RunHeadlessPurchaseParams): Promise<CreateOutcome | "stopped"> {
  const check = await preCheck({ quote, config, pm, paymentMethod });
  if (isCancelled() || check.outcome !== "pass") {
    return "stopped";
  }
  return create({
    quote,
    config,
    pm,
    instrument: { ...instrument, challengeToken: check.challengeToken },
    isCancelled,
    kycStepUp,
  });
}
